<div class="password-strength">
  <div class="password-strength__header">
    <span class="text-xs font-medium text-neutral-gray70">
      {{ 'auth.passwordStrength.label' | translate }}
    </span>
    <span
      class="text-xs font-medium"
      [class.text-functional-error]="strength === 'weak'"
      [class.text-functional-warning]="strength === 'medium'"
      [class.text-functional-success]="strength === 'strong'"
      [class.text-neutral-gray40]="strength === 'none'">
      <ng-container [ngSwitch]="strength">
        <span *ngSwitchCase="'weak'">{{ 'auth.passwordStrength.weak' | translate }}</span>
        <span *ngSwitchCase="'medium'">{{ 'auth.passwordStrength.medium' | translate }}</span>
        <span *ngSwitchCase="'strong'">{{ 'auth.passwordStrength.strong' | translate }}</span>
        <span *ngSwitchDefault>&nbsp;</span>
      </ng-container>
    </span>
  </div>

  <div
    class="password-strength__meter"
    role="progressbar"
    aria-valuemin="0"
    aria-valuemax="100"
    [attr.aria-valuenow]="meterPercent">
    <div
      class="password-strength__meter-fill"
      [style.width.%]="meterPercent"
      [class.is-weak]="strength === 'weak'"
      [class.is-medium]="strength === 'medium'"
      [class.is-strong]="strength === 'strong'"></div>
  </div>

  <ul class="password-strength__rules">
    <li [class.is-met]="rules.length">
      <i class="pi" [ngClass]="rules.length ? 'pi-check' : 'pi-circle'" aria-hidden="true"></i>
      <span>{{ 'auth.passwordStrength.ruleLength' | translate }}</span>
    </li>
    <li [class.is-met]="rules.upper">
      <i class="pi" [ngClass]="rules.upper ? 'pi-check' : 'pi-circle'" aria-hidden="true"></i>
      <span>{{ 'auth.passwordStrength.ruleUpper' | translate }}</span>
    </li>
    <li [class.is-met]="rules.lower">
      <i class="pi" [ngClass]="rules.lower ? 'pi-check' : 'pi-circle'" aria-hidden="true"></i>
      <span>{{ 'auth.passwordStrength.ruleLower' | translate }}</span>
    </li>
    <li [class.is-met]="rules.digit">
      <i class="pi" [ngClass]="rules.digit ? 'pi-check' : 'pi-circle'" aria-hidden="true"></i>
      <span>{{ 'auth.passwordStrength.ruleDigit' | translate }}</span>
    </li>
    <li [class.is-met]="rules.symbol">
      <i class="pi" [ngClass]="rules.symbol ? 'pi-check' : 'pi-circle'" aria-hidden="true"></i>
      <span>{{ 'auth.passwordStrength.ruleSymbol' | translate }}</span>
    </li>
  </ul>
</div>
